@if (state() !== 'missing') {
  <div class="pe-picture" aria-hidden="true">
    @if (card(); as card) {
      <a class="pe-picture__link" [routerLink]="card.link" tabindex="-1">
        <img class="pe-image" [src]="card.imageUrl" alt="" width="136" height="136"
             loading="lazy" decoding="async" (error)="onImageError($event)" />
      </a>
    } @else {
      <span class="pe-image pe-image--loading"></span>
    }
  </div>
}
<div class="pe-body">
  <ng-content></ng-content>
  @if (card(); as card) {
    <a class="pe-view" [routerLink]="card.link" [attr.aria-label]="'View ' + card.name">
      View product
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7M8 7h9v9" /></svg>
    </a>
  }
</div>
